<template>
    <b-progress id="zhaw-progress-bar" :value="progressValue" variant="primary" striped :animated="isAnimated"></b-progress>
</template>

<script>
    export default {
        name: "ProgressBar",
        props: {
            progressValue: Number,
            isAnimated: Boolean
        }
    }
</script>

<style scoped>
    #zhaw-progress-bar {
        margin-top: 10px;
        margin-bottom: 20px;
    }
</style>